import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
const HajjTabs = (props) => {
    const { user } = useAuth();
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/hajj"} className={props.pageName === "HAJJPACKAGE" ? "nav-link active bg-primary text-white" : "nav-link"}>HAJJ</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/hajjlist"} className={props.pageName === "HAJJPACKAGES" ? "nav-link active bg-primary text-white" : "nav-link"}>HAJJ PACKAGES</Link>
                </li>    
                {user && user.isWebsite && (
        <li className="nav-item" role="presentation">
            <Link 
                to={"/websitehajjpackages"} 
                className={props.pageName === "WEBSITEHAJJPACKAGES" ? "nav-link active bg-primary text-white" : "nav-link"}
            >
                WEBSITE HAJJ PACKAGES
            </Link>
        </li>
      )}              
                 <li className="nav-item" role="presentation">
                    <Link to={"/hajjenquiry"} className={props.pageName === "HAJJENQUIRIES" ? "nav-link active bg-primary text-white" : "nav-link"}>HAJJ ENQUIRIES</Link>
                </li>
                {/* <li className="nav-item" role="presentation">
                    <Link to={"/packagedates"} className={props.pageName === "PACKAGEDATES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE DATES</Link>
                </li> */}
            </ul>
    );
};

export default HajjTabs;
